;(function (root, factory, undef) {
	if (typeof exports === "object") {
		// CommonJS
		module.exports = exports = factory(require("./core"), require("./sha1"), require("./hmac"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA1;

}));


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/~/crypto-js/hmac-sha1.js
// module id = ../../../../crypto-js/hmac-sha1.js
// module chunks = 3